import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateProjectArchiveMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.post(`/projects/${id}/archives`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['projectReports']);
      queryClient.invalidateQueries(['projectsDashboardNavigationOptions']);
    },
  });
}

export function useCreateProjectRestorationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.post(`/projects/${id}/restorations`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['projectReports']);
      queryClient.invalidateQueries(['projectsDashboardNavigationOptions']);
    },
  });
}

export function useDestroyProjectMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/projects/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['projectReports']);
      queryClient.invalidateQueries(['projectsDashboardNavigationOptions']);
    },
  });
}

export function useCreateProjectsBulkArchiveMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bulkArchiveParams }) => {
      const response = await axios.post('/projects/bulk_archives', {
        bulk_archive: bulkArchiveParams,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['projectReports']);
      queryClient.invalidateQueries(['projectsDashboardNavigationOptions']);
    },
  });
}

export function useCreateProjectDuplicationProcessMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ duplicationProcessParams, id }) => {
      const response = await axios.post(
        `/projects/${id}/duplication_processes`,
        { duplication_process: duplicationProcessParams },
      );
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['duplicationProcesses']),
  });
}
